<template>
  <v-row no-gutters ref="widget">
    <v-col cols="12" sm="6">
      <amount-sheet :readonly="true" />
    </v-col>
    <v-col cols="12" sm="6">
      <v-sheet class="my-3 overflow-hidden" rounded outlined>
        <v-card-text>
          <v-row align="center" no-gutters>
            <v-col cols="8">
              <v-btn class="ml-1" @click="$router.push({ name: 'PaymentLink', params: { pk: $route.params.pk } })" color="primary" :ripple="false" text><v-icon left>mdi-arrow-left</v-icon>Volver</v-btn>
            </v-col>
            <v-col class="text-right" cols="4">
              <img :src="require(`@/assets/appAsset-brand--mercadopago.svg`)" alt="mercadopago" height="28">
            </v-col>
            <v-col class="py-2" cols="12">
              <span class="text--secondary font-weight-medium">Información de la tarjeta</span>
            </v-col>
          </v-row>
          <v-row align="center" justify="start">
            <!-- non PCI Fields -->
            <v-col cols="6" sm="5" md="4" lg="4" class="py-1">
              <span class="font-weight-medium">RUT del pagador</span>
              <v-text-field v-model="$v.fields.docNumberMasked.$model" v-dni="'CL'" :error="$v.fields.docNumberMasked.$error || $v.fields.docNumber.$error" background-color="white" outlined required single-line dense maxlength="12" persistent-hint hide-details />
            </v-col>
            <v-col cols="12" class="py-1">
              <span class="font-weight-medium">Titular de la tarjeta</span>
              <v-text-field v-model="$v.fields.cardholderName.$model" :error="$v.fields.cardholderName.$error" background-color="white" outlined required single-line dense maxlength="80" persistent-hint hide-details />
            </v-col>
            <!-- end non PCI Fields -->

            <!-- PCI Fields -->
            <v-col cols="12" sm="6" md="7" lg="7" class="py-1">
              <span class="font-weight-medium">Número de la tarjeta</span>
              <div class="pci-field" id="cardNumber"></div>
            </v-col>
            <v-col cols="6" sm="3" md="3" lg="3" class="py-1">
              <span class="font-weight-medium">Vencimiento</span>
              <div class="pci-field" id="expirationDate"></div>
            </v-col>
            <v-col cols="6" sm="3" md="2" lg="2" class="py-1">
              <span class="font-weight-medium">CVV</span>
              <div class="pci-field" id="securityCode"></div>
            </v-col>
            <!-- end PCI Fields -->
          </v-row>
        </v-card-text>

        <v-divider />

        <v-card-text class="background">
          <v-row align="center" justify="start" no-gutters>
            <!-- PCI Fields error messages -->
            <v-col v-if="Object.values(errorMessages).some(v => v === true) && !loaderMain" cols="12">
              <v-alert class="my-0 mb-4 body-2" dark dense prominent color="red lighten-4" border="left">
                <span class="d-block py-1 red--text darken-4" v-if="errorMessages.cardNumber">Verifica el número de la tarjeta</span>
                <span class="d-block py-1 red--text darken-4" v-if="errorMessages.expirationDate">Verifica la fecha de vencimiento</span>
                <span class="d-block py-1 red--text darken-4" v-if="errorMessages.securityCode">Verifica el código de seguridad</span>
              </v-alert>
            </v-col>
            <!-- end PCI Fields error messages -->

            <v-col cols="12">
              <v-btn @click="pay" :style="{'background-color': `${instance.account.color_background} !important`}" :loading="loaderMain" height="40" block dark>
                <template v-if="instance.cta === 'pay'">Pagar</template>
                <template v-else-if="instance.cta === 'donate'">Donar</template>
                <template v-else-if="instance.cta === 'book'">Reservar</template>
              </v-btn>
            </v-col>
            <v-col cols="12">
              <span class="d-block mt-4 body-2 text--primary">Pago procesado de forma segura a través de MercadoPago</span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-sheet>
      <piriod-sign text="cobra con los enlaces de pago de" />
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { maxLength, required } from 'vuelidate/lib/validators'
import { loadMercadoPago } from '@mercadopago/sdk-js'
import { rutValidator } from 'vue-dni'

import AmountSheet from '../../components/payment-links/AmountSheet'
import PiriodSign from '../../components/base/PiriodSign'

import GenericViewMixin from '../../mixins/GenericViewMixin'
import WidgetViewMixin from '../../mixins/WidgetViewMixin'

export default {
  name: 'piriod-gateway-mercadopago',
  mixins: [
    GenericViewMixin,
    WidgetViewMixin
  ],
  components: {
    AmountSheet,
    PiriodSign
  },
  data: () => ({
    brand: '',
    brands: {
      amex: 'AmericanExpress',
      debmaster: 'MasterCard',
      debvisa: 'Visa',
      diners: 'Diners',
      master: 'MasterCard',
      redcompra: 'RedCompra',
      visa: 'Visa'
    },
    errorMessages: {
      cardNumber: false,
      expirationDate: false,
      securityCode: false
    },
    fields: {
      cardholderName: '',
      docNumber: '',
      docNumberMasked: '',
      docType: 'RUT'
    },
    loaderMain: false,
    provider: null
  }),
  computed: mapState({
    amount: state => state.paymentLinks.linksAmount,
    customer: state => state.paymentLinks.intentCustomer,
    instance: state => state.paymentLinks.linksDetail
  }),
  watch: {
    'fields.docNumberMasked' () {
      if (this.fields.docNumberMasked) {
        this.$v.fields.docNumber.$model = this.fields.docNumberMasked.replace(/[.-]/g, '')
      }
    }
  },
  async mounted () {
    // load mercadopago script
    await loadMercadoPago()
  },
  created () {
    setTimeout(() => {
      this.initProvider()
    }, 200)
  },
  methods: {
    async pay () {
      // validate fields
      this.$v.fields.$touch()
      if (this.$v.fields.$invalid) {
        return false
      }

      this.loaderMain = true

      // create card token using mercadopago
      let providerToken = null

      try {
        providerToken = await this.provider.fields.createCardToken({
          cardholderName: this.fields.cardholderName,
          identificationType: this.fields.docType,
          identificationNumber: this.fields.docNumber
        })
      } catch (error) {
        // reset error messages
        Object.keys(this.errorMessages).forEach(k => {
          this.errorMessages[k] = false
        })

        if (Array.isArray(error)) {
          error.forEach(err => {
            this.errorMessages[err.field] = true
          })
        }

        this.loaderMain = false
        return
      }

      const payload = {
        amount: this.amount,
        customer: this.customer,
        gateway: 'mercadopago',
        link: this.$route.params.pk,
        client: {
          token: providerToken.id
        }
      }

      // perform payment
      this.$store.dispatch('paymentLinks/CREATE', {
        resource: 'publishable/payment_links/intents',
        payload: payload
      })
      .then(() => {
        // redirect to display intent result
        this.$router.push({ name: 'IntentRetrieve' })
      })
      .catch((error) => {
        console.log('error', error)
      })
      .finally(() => {
        this.loaderMain = false
      })
    },
    initProvider () {
      /**
       * Initialize mercadopago provider
       */
      this.provider = new window.MercadoPago(this.instance.merchants.mercadopago)

      const customFonts = [{
        src: 'https://fonts.googleapis.com/css2?family=Open+Sans&display=swap'
      }]
      const fieldStyles = {
        color: '#6A8699',
        fontFamily: '-apple-system, BlinkMacSystemFont, Open Sans',
        fontSize: '15px',
        fontWeight: '400'
      }

      // create fields
      this.$nextTick(() => {
        this.provider.fields.create('cardNumber', {
          customFonts: customFonts,
          placeholder: '',
          style: fieldStyles
        }).mount('cardNumber')

        this.provider.fields.create('expirationDate', {
          customFonts: customFonts,
          placeholder: 'MM/AA',
          style: fieldStyles
        }).mount('expirationDate')

        this.provider.fields.create('securityCode', {
          customFonts: customFonts,
          placeholder: '',
          style: fieldStyles
        }).mount('securityCode')
      })

      // set identification types
      this.provider.getIdentificationTypes()
    },
    setLanguaje () {
      this.$v.options.locale.value.$touch()

      if (this.$v.options.locale.value.$invalid) {
        console.info('Unsupported value in piriodSettings.options.locale, must be one of [es_MX, en_US, po_BR]')
      } else {
        this.$i18n.locale = this.options.locale.value
      }
    }
  },
  validations: {
    fields: {
      cardholderName: {
        required,
        maxLength: maxLength(80)
      },
      docNumber: {
        required,
        maxLength: maxLength(10),
        taxId: function (val) {
          return rutValidator(val)
        }
      },
      docNumberMasked: {
        required,
        maxLength: maxLength(12)
      }
    }
  }
}
</script>
<style>
.pci-field {
  background-color: #FFFFFF;
  border: 1px solid #D7E0EA;
  height: 40px;
  border-radius: 6px;
  padding: 0 10px;
}
</style>